"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectDynamicLookupNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'OBJECT-DYNAMIC-LOOKUP';
class ObjectDynamicLookupNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const input = params.input;
            const ret = {
                result: input === null || input === void 0 ? void 0 : input[params.key]
            };
            return ret;
        };
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        //set up the basic outputParams schema
        const OutputParams = {
            type: 'object',
            properties: { result: BaseNode_1.BaseNode.getProp(this.config.resultType, 'result') },
        };
        return Object.assign(Object.assign({}, Schema), { InputParams: this._interfaceDefinition.definitions.InputParams, OutputParams: OutputParams, ConfigParams: {
                type: 'object',
                properties: {
                    resultType: BaseNode_1.BaseNode.getTypeOptions(true),
                },
            } });
    }
}
exports.ObjectDynamicLookupNode = ObjectDynamicLookupNode;
ObjectDynamicLookupNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Object Dynamic Lookup',
    isIdempotent: true,
    primaryCategory: 'Collection',
};
//# sourceMappingURL=ObjectDynamicLookup.js.map